import React, { useRef,useEffect,useState } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../../atoms/checkbox/checkbox';
import FormValidation from '../../atoms/formEnums/formValidation';
import Label from '../../atoms/label/label';
import './formCheckbox.scss';
import swal from 'sweetalert';
// import { check } from 'prettier';

/**
 * Form Checkbox Select molecule has been designed to group checkbox atoms. It has an array with the value of checkbox checked. Designed to define multi options attribute inside a form.
 */
const FormCheckbox = (props) => {
  const {
    label, validation, checked, helpText, errorText, onChange, id, labelForm, disabled, confirmPopup, confirmText, defaultValue, hidden
  } = props;

  const childRef = useRef();
  const [myChecked,setMyChecked]=useState(checked?checked:(defaultValue?true:false));

  const handleChangeCheckbox = (newValue) => {
    
      var value=newValue.target.checked;
      newValue.persist();
      if(confirmPopup){
        swal({
          title: 'Are you sure?',
          text: confirmText,
          icon: 'warning',
          buttons: true,
          dangerMode: true,
        }).then((ok) => {
          if (ok) {
            // console.log("step1",value);
            let v={target:{checked:value,type:'checkbox'}};
            // console.log(v);
            setMyChecked(value);
            onChange(v);
          }
        });
      }else{
        onChange(newValue);
        setMyChecked(value);
      }
    
  };
 
  useEffect(() => {
  if (checked !== undefined && checked !== null) {
    setMyChecked(Boolean(checked));
  } else {
    if (defaultValue) setMyChecked(defaultValue);
  }
}, [checked]);

  if (hidden) {
  return null;
  }
  return (
    <div className={`form-checkbox form-group row text-${validation}`}>
      <Label className={(labelForm=="true"?"labelTop":"")} helpText={helpText}>{label}</Label>
      <div className={(labelForm=="true"?"col-form-label":"col-sm-8 col-form-label")}>
        <Checkbox
          ref={childRef}
          onChange={handleChangeCheckbox}
          checked={myChecked}
          disabled={disabled}
          id={id}
          confirmPopup={confirmPopup}
          confirmText={confirmText}
        />
        { (validation === FormValidation.ERROR
          || validation === FormValidation.WARNING)
          && (
            <small className="form-text">{errorText}</small>
          )}
      </div>
    </div>
  );
};

FormCheckbox.propTypes = {
  /**
   * Id of checkbox input
   */
  id: PropTypes.string,
  /**
   * Name of checkbox attribute
   */
  label: PropTypes.string.isRequired,
  /**
   * If the checkbox is selected
   */
  checked: PropTypes.bool,
  /**
   * If the disabled is selected
   */
   disabled: PropTypes.bool,
  /**
   * Select form status, it is a FormValidation enum
   */
  validation: PropTypes.oneOf(Object.values(FormValidation)),
  /**
   * Checkbox help text
   */
  helpText: PropTypes.string,
  /**
   * Defined text errors
   */
  errorText: PropTypes.string,
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
  /**
   * bool =true if we want to come up a popup to be sure the changes has to be made
   */
  confirmPopup:PropTypes.bool,
  /**
   * The specific text you would like to show, if not defined a generic message is shown
   */
  confirmText:PropTypes.string,
  hidden:PropTypes.bool,
};

FormCheckbox.defaultProps = {
  id: '',
  helpText: '',
  errorText: '',
  checked: false,
  disabled:false,
  confirmPopup:false,
  confirmText:"",
  onChange: () => {},
  validation: FormValidation.PENDING,
  hidden: false,
};

export default FormCheckbox;
